import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDimension = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10.114 2.9a.25.25 0 0 0-.228 0l-6 3.07a.25.25 0 0 0-.136.222v6.896c0 .089.046.17.122.215l6 3.563a.25.25 0 0 0 .256 0l6-3.563a.25.25 0 0 0 .122-.215V6.192a.25.25 0 0 0-.136-.222zm-.911-1.335a1.75 1.75 0 0 1 1.594 0l6 3.07c.585.299.953.9.953 1.557v6.896a1.75 1.75 0 0 1-.857 1.505l-6 3.563a1.75 1.75 0 0 1-1.786 0l-6-3.563a1.75 1.75 0 0 1-.857-1.505V6.192c0-.657.368-1.258.953-1.558z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M3.102 5.875a.5.5 0 0 1 .68-.192L10 9.164l6.217-3.481a.5.5 0 1 1 .489.872L10.5 10.03v7.246a.5.5 0 0 1-1 0V10.03L3.294 6.555a.5.5 0 0 1-.192-.68"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDimension;
